/** @jsxImportSource @emotion/react */
import * as React from 'react';
import * as R from 'ramda';
import { css, keyframes, SerializedStyles } from '@emotion/react';
import { BLUE_CREEK } from '../../../styles/colors';
import { ANIMATION_DELAY_INTERVAL, BLADE_ANGLE, DEFAULT_BLADE_COUNT } from './config';


const startLoadingKeyframes = keyframes`
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;


/**
 * IosSpinner: a component that renders an iOS-style spinner with the spinning, fading fan blade style.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class IosSpinner extends React.PureComponent<{
  bladeCount?: number;
  color?: string;
  rootCss?: SerializedStyles;
}> {
  public static makeBlades = (color, bladeCount) => R.range(0, bladeCount)
    .map(i => <div key={i}
                   css={css`
                     position: absolute;
                     width: 7%;
                     height: 25%;
                     left: 47%;
                     top: 37%;
                     background: ${color};
                     opacity: 0;
                     border-radius: 50px;
                     box-shadow: 0 0 3px rgba(0,0,0,0.2);
                     animation: fade 1s linear infinite;
                     transform: rotate(${i * BLADE_ANGLE}deg) translate(0, -130%);
                     animation-delay: ${i * ANIMATION_DELAY_INTERVAL - 1}s;
                   `}/>,
    );


  public render = () => (
    <div css={css`
            width: 50px;
            height: 50px;
            margin: auto;
            animation: ${startLoadingKeyframes} .6s;

            @keyframes fade {
              from {opacity: 1;}
              to {opacity: 0.25;}
            }

            ${this.props.rootCss};
         `}>
      <div css={css`
               position: relative;
               width: 100%;
               height: 100%;
             `}>
        {IosSpinner.makeBlades(this.props.color || BLUE_CREEK, this.props.bladeCount || DEFAULT_BLADE_COUNT)}
      </div>
    </div>
  );
}
